module.exports = __webpack_public_path__ + "static/media/shirts3.f89d021f.jpg";